import { SHIPT_SESSION_KEY, SHIPT_SESSION_EXPIRY_KEY, returnSessionInfo, get30MinutesFromNow, } from "@shipt/analytics-core";
const sessionData = {
    currentSessionId: null,
    expiryMs: null,
};
// normalize storage to work with shared logic
const normalizedStorage = {
    // Android WebView doesn't guarantee localstorage is present
    get: (key) => localStorage === null || localStorage === void 0 ? void 0 : localStorage.getItem(key),
    set: (key, value) => localStorage === null || localStorage === void 0 ? void 0 : localStorage.setItem(key, value),
};
export const getSessionInfo = () => returnSessionInfo(sessionData, normalizedStorage);
// add event listener that will store the session id and expiry key in storage before unloading the window
if (typeof window !== "undefined") {
    window.addEventListener("pagehide", function () {
        // reset the 30 minutes inactivity ms tracker every time this function gets called
        normalizedStorage.set(SHIPT_SESSION_EXPIRY_KEY, String(get30MinutesFromNow()));
        normalizedStorage.set(SHIPT_SESSION_KEY, String(sessionData.currentSessionId));
    });
}
